export const CUSTOM_RANGE_ID = 'custom'
